'use strict'

const imageElements = require('../../components/imageCommon/utils/imageElements')

module.exports = {
    imageElements
}